<template>
  <head>
    <title>
      {{ $t("OurPartneres.title") }}
    </title>
  </head>
  <div class="our-partners-view">
    <AdminSidebar>
      <TableComponent
        :titles="titles"
        :data="data"
        :title="title"
        :pageUrl="pageUrl"
        deleteApi="api/delete_partners"
        EditUrl="/update-partner"
      />
    </AdminSidebar>
  </div>
</template>

<script>
import store from "@/store";
import axios from "axios";
import AdminSidebar from "@/components/AdminDashboard/AdminSidebar.vue";
import TableComponent from "@/components/AdminDashboard/TableComponent.vue";

export default {
  name: "our-partners-view",
  data() {
    return {
      data: {},
      ErrorMessage: "",
      titles: [
        "id",
        "name_en",
        "name_ar",
        "description_en",
        "description_ar",
        "delete",
        "update",
        "show",
      ],
      title: "OurPartneres.title",
      pageUrl: "AddNewPartners",
    };
  },
  methods: {
    getData() {
      store.state.loading_state = 1;
      axios
        .get(store.state.server + "api/get_all_partners")
        .then((response) => {
          this.data = response.data;
          store.state.loading_state = 0;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getData();
  },
  components: {
    AdminSidebar,
    TableComponent,
  },
};
</script>
